import React from "react";
import { Outlet } from "react-router-dom";
import DashboardLayout from "../../components/layout/DashboardLayout";

const NAV = [
  { to: "/org",          label: "Overview",   icon: "▦",  end: true },
  { to: "/org/branches", label: "Branches",   icon: "🏢" },
  { to: "/org/staff",    label: "Staff",      icon: "👥" },
  { to: "/org/reports",  label: "Reports",    icon: "📊" },
  { to: "/org/admins",   label: "Org Admins", icon: "👤" },
  { to: "/org/activity", label: "Activity",   icon: "🔔" },
];

export default function OrgAdminLayout() {
  return (
    <DashboardLayout navItems={NAV} sectionLabel="Org Admin">
      <Outlet />
    </DashboardLayout>
  );
}
